import { ImageStyle, TextStyle, ViewStyle } from "react-native";

import { ITheme } from "../theme/Theme.types";

// style objects and functions
export type Style = ViewStyle | TextStyle | ImageStyle;
export type ThemeStyle = (theme: ITheme) => Style;
export type ClassType = Style | ThemeStyle;

// class group type ex: const myClasses = { class1: {}, class2: {} };
export type ClassGroupType<T> = { [key in keyof T]: T[key] };

interface DynamicClass {
  prop: string;
  type: "string" | "number";
}

export const DynamicClassMapper: { [key: string]: DynamicClass } = {
  p: {
    prop: "padding",
    type: "number",
  },
  pt: {
    prop: "paddingTop",
    type: "number",
  },
  pr: {
    prop: "paddingRight",
    type: "number",
  },
  pl: {
    prop: "paddingLeft",
    type: "number",
  },
  pb: {
    prop: "paddingBottom",
    type: "number",
  },
  ph: {
    prop: "paddingHorizontal",
    type: "number",
  },
  pv: {
    prop: "paddingVertical",
    type: "number",
  },
  m: {
    prop: "margin",
    type: "number",
  },
  mt: {
    prop: "marginTop",
    type: "number",
  },
  mr: {
    prop: "marginRight",
    type: "number",
  },
  ml: {
    prop: "marginLeft",
    type: "number",
  },
  mb: {
    prop: "marginBottom",
    type: "number",
  },
  mh: {
    prop: "marginHorizontal",
    type: "number",
  },
  mv: {
    prop: "marginVertical",
    type: "number",
  },
  color: {
    prop: "color",
    type: "string",
  },
  bgColor: {
    prop: "backgroundColor",
    type: "string",
  },
  h: {
    prop: "height",
    type: "number",
  },
  w: {
    prop: "width",
    type: "number",
  },
  maxW: {
    prop: "maxWidth",
    type: "number",
  },
  maxH: {
    prop: "maxHeight",
    type: "number",
  },
  minW: {
    prop: "minWidth",
    type: "number",
  },
  minH: {
    prop: "minHeight",
    type: "number",
  },
  flex: {
    prop: "flex",
    type: "number",
  },
  grow: {
    prop: "flexGrow",
    type: "number",
  },
  shrink: {
    prop: "flexShrink",
    type: "number",
  },
  gap: {
    prop: "gap",
    type: "number",
  },
  rowGap: {
    prop: "rowGap",
    type: "number",
  },
  br: {
    prop: "borderRadius",
    type: "number",
  },
  bw: {
    prop: "borderWidth",
    type: "number",
  },
  bwBottom: {
    prop: "borderBottomWidth",
    type: "number",
  },
  bwTop: {
    prop: "borderTopWidth",
    type: "number",
  },
  fontSize: {
    prop: "fontSize",
    type: "number",
  },
  opacity: {
    prop: "opacity",
    type: "number",
  },
  top: {
    prop: "top",
    type: "number",
  },
  right: {
    prop: "right",
    type: "number",
  },
  left: {
    prop: "left",
    type: "number",
  },
  bottom: {
    prop: "bottom",
    type: "number",
  },
};
